import { jsxs, jsx } from 'react/jsx-runtime';
import { useModalContext } from '@sketch/components';
import { StyledButton, StyledResponsiveImage, Title, Description } from './Practice.styles.js';
import '../../hooks/index.js';
import '../../modals/PracticeModal/index.js';
import { useTrackEvent } from '../../hooks/useTrackEvent.js';
import { useTrackEventInView } from '../../hooks/useTrackEventInView.js';
import PraticeModal from '../../modals/PracticeModal/PracticeModal.js';

/**
 *
 * Pratice
 *
 * This components renders the items for the "Pratice"  section
 * in the Discover page.
 */
const Practice = ({ image, title, content, url }) => {
    const { showModal } = useModalContext();
    // Analytics
    const { trackEvent } = useTrackEvent();
    const { ref } = useTrackEventInView('DISCOVER - Pratice', {
        type: 'load',
        target: title,
    });
    if (!url || !title) {
        return null;
    }
    return (jsxs(StyledButton, Object.assign({ onClick: () => {
            trackEvent('DISCOVER - Pratice', {
                type: 'click',
                target: title,
            });
            showModal(PraticeModal, {
                title,
                url,
            });
        } }, { children: [jsx(StyledResponsiveImage, { image: image, withSkeletonUI: true }), jsx(Title, Object.assign({ ref: ref }, { children: title })), jsx(Description, { children: content })] })));
};

export { Practice as default };
